// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1-Wz4","content":"ManualTimeModal_content__2gGE-"};